import { render } from "./Spinner.vue?vue&type=template&id=248acdc5"
import script from "./Spinner.vue?vue&type=script&lang=ts"
export * from "./Spinner.vue?vue&type=script&lang=ts"

import "./Spinner.vue?vue&type=style&index=0&id=248acdc5&lang=scss"
script.render = render

export default script